<span [class]="pillClass" [attr.data-testid]="testid || null">{{ displayLabel }}</span>
